import * as React from 'react';
import ChatHistory from "./ChatHistory";
import {useEffect, useRef, useState} from "react";


export default function Chat() {

    const [history, setHistory] = useState(
        [
            {
                author: "sys",
                content: "Welcome to LLM Architect!\n " +
                    "I'm here to assist you in building a microservice architecture for your app idea. \n " +
                    "Start by discussing your idea and technical considerations with me. \n " +
                    "Once finished, press the architect button to view the result.",
                loading: false
            }
        ]
    );
    const inputRef = useRef(null);

    useEffect(() => {
        const requestOptions = {
            method: 'GET'
        };
        fetch('http://3.23.60.181/init', requestOptions)
            .then(response => response.json())

    }, []);

    useEffect(() => {
        console.log( history)
        var lastMessage = history[history.length-1]

        if(lastMessage.author === "user"){
            inputRef.current.disabled = true;

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt: lastMessage.content })
            };

            setHistory([...history, {author: "ai", loading: true, content:  ""}]);

            fetch('http://3.23.60.181/chat', requestOptions)
                .then(response => response.json())
                .then(data => setHistory([...history, {author: "ai",  loading: false,  content:  data.prompt_response}]));


            inputRef.current.disabled = false;
        }
    }, [history]);


    async function handleMessage(inputRef) {
        if (inputRef.current.value.length > 0) {
            // inputRef.current.disabled = true;
            console.log("handleMessage")

            setHistory([...history, {author: "user", loading: false,  content: inputRef.current.value}]);

            /*   var millisecondsToWait = 10000;
               setTimeout(function () {
                   setHistory([...history, "and another"]);
                   // Whatever you want to do after the wait
               }, millisecondsToWait);*/


            /* var millisecondsToWait = 5000;
             setTimeout(function() {
                 setHistory([...history, "AI Response Message"]);
                 inputRef.current.disabled = false;
             }, millisecondsToWait);*/
            //handleResponse("hello");
            inputRef.current.value = "";
        }
    }


    return (
        <div>
            <ChatHistory history={history}/>
            <div className="chat-input-wrapper">
                <input name="myInput" ref={inputRef}
                       className="chat-input" placeholder="Discuss your app with the architect..."
                       onKeyDown={
                           e => {
                               if (e.key === "Enter") {
                                   handleMessage(inputRef)
                               }
                           }}/>
                <span className="chat-icon-left material-symbols-outlined">bolt</span>
                <span className="chat-icon-right material-symbols-outlined" onClick={
                    e => {
                        handleMessage(inputRef)
                    }}>send</span>
            </div>
            <p className="chat-input-label">This app may produce flawed, ineffective or otherwise defective
                software architectures. </p>
            <button className="button-9">Architect It</button>
        </div>

    );
}